import {DragEndEvent} from '@dnd-kit/core';
import {useCallback} from 'react';

import {useViewAction} from '../../state/views/hooks';
import * as Actions from '../../state/views/panelBankConfig/actions';
import {useWorkspaceRefsContext} from '../Workspace/WorkspaceRefsContext';

export const useHandleDragEnd = () => {
  const {panelBankConfigRef} = useWorkspaceRefsContext();

  const moveSection = useViewAction(panelBankConfigRef, Actions.moveSection);

  const handleDragEnd = useCallback(
    (event: DragEndEvent) => {
      const {active, over} = event;

      // Only proceed if we have both active and over, and they're different
      if (!over || active.id === over.id) {
        return;
      }

      const dragType = active.data.current?.type;

      // Only handle section drags for now
      // TOOD: remove check when we handle panel drags
      if (dragType !== 'section') {
        return;
      }

      const activeSectionRefId = active.id.toString();
      const targetSectionRefId = over.id.toString();
      moveSection(activeSectionRefId, targetSectionRefId);
    },
    [moveSection]
  );

  return handleDragEnd;
};
